export default "__VITE_PUBLIC_ASSET__e5e29359__"